<script setup lang="ts">
/**
 * Client name cell for the Finances table: shows the name on the primary
 * line and, when `flagged` is true (negative balance with no visits this
 * period — see `isFlagged` in `FinancesTab`), a second line in the
 * money-negative color reading "no visits in period" — mirrors
 * `ClientNameCell`'s name/meta layout but with a danger-colored flag
 * instead of gender/start-date metadata.
 */
import { useI18n } from 'vue-i18n'

const props = withDefaults(
  defineProps<{
    /** Client display name. */
    name: string
    /** True when the client has a negative balance and no visits in the selected period. */
    flagged?: boolean
    /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
    maxWidth?: string
  }>(),
  { flagged: false },
)

const { t } = useI18n()
</script>

<template>
  <td
    class="finance-client-name-cell text-tufte-text font-tufte"
    :style="props.maxWidth ? { maxWidth: props.maxWidth, overflowWrap: 'break-word' } : undefined"
  >
    <div class="flex flex-col gap-0.5">
      <span>{{ props.name }}</span>
      <span v-if="props.flagged" class="finance-client-name-cell__flag">{{
        t('tabs.finances.noVisitsInPeriod')
      }}</span>
    </div>
  </td>
</template>

<style scoped>
.finance-client-name-cell {
  font-size: var(--text-tufte-lg);
}

.finance-client-name-cell__flag {
  font-size: var(--text-tufte-xs);
  color: var(--color-money-negative);
  line-height: var(--line-height-tufte-normal);
  white-space: nowrap;
}
</style>
